import { useEffect } from "react";
import { useNotification, useOnLineStatus } from "@/hooks";
export default function NetworkNotification() {
  const onLine = useOnLineStatus();
  const {
    showNotification,
    hideNotification
  } = useNotification();
  useEffect(() => {
    if (!onLine) {
      showNotification("インターネットに接続されていません", {
        caution: true,
        fixed: true
      });
    } else {
      hideNotification({
        caution: true
      });
    }
  }, [onLine]);
  return null;
}